"use strict";

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var HTMLCollection = require("../generated/HTMLCollection");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var _require = require("../helpers/traversal"),
    descendantsByLocalName = _require.descendantsByLocalName;

var HTMLDataListElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLDataListElementImpl, _HTMLElementImpl);

  function HTMLDataListElementImpl() {
    _classCallCheck(this, HTMLDataListElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLDataListElementImpl).apply(this, arguments));
  }

  _createClass(HTMLDataListElementImpl, [{
    key: "options",
    // https://html.spec.whatwg.org/multipage/form-elements.html#dom-datalist-options
    get: function get() {
      var _this = this;

      return HTMLCollection.createImpl([], {
        element: this,
        query: function query() {
          return descendantsByLocalName(_this, "option");
        }
      });
    }
  }]);

  return HTMLDataListElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLDataListElementImpl
};